module.exports = __webpack_public_path__ + "img/ic_survey_answer_selected.af44238d.svg";